/**
 * Campaign list and detail page APIs.
 */
import { apihubGet } from "./apihub";
import {
  fetchAllcampaignByPhoneNoId,
  fetchCampaigndetailsById,
  postGetidandnameofcampaign,
} from "./customer.api";

/** Unwrap `{ success, data }` or return a flat campaign object. */
export function normalizeCampaignDetails(response) {
  if (!response || typeof response !== "object") return null;
  const nested = response.data;
  if (
    nested &&
    typeof nested === "object" &&
    (nested.campaignName || nested._id || nested.campaignstatus != null)
  ) {
    return nested;
  }
  if (response.campaignName || response._id || response.campaignstatus != null) {
    return response;
  }
  return nested ?? response;
}

/** Read a metric from either an ID array (`sent`) or a count field (`sentCount`). */
export function getCampaignMetricCount(campaign, arrayKey, countKey) {
  const arr = campaign?.[arrayKey];
  if (Array.isArray(arr) && arr.length > 0) return arr.length;
  const count = campaign?.[countKey];
  if (count != null && count !== "") return Number(count) || 0;
  return 0;
}

export function unwrapCampaignStatusPayload(res) {
  if (Array.isArray(res)) {
    return { data: res, total: res.length };
  }
  if (!res || typeof res !== "object") {
    return { data: [], total: 0 };
  }
  if (Array.isArray(res.data)) {
    return {
      data: res.data,
      total: Number(res.total) || res.data.length,
      page: res.page,
      limit: res.limit,
    };
  }
  const nested = res.data;
  if (nested && typeof nested === "object" && Array.isArray(nested.data)) {
    return {
      data: nested.data,
      total: Number(nested.total ?? res.total) || nested.data.length,
      page: nested.page ?? res.page,
      limit: nested.limit ?? res.limit,
    };
  }
  return { data: [], total: Number(res.total) || 0 };
}

export async function fetchCampaignDetails(campaignId) {
  const res = await fetchCampaigndetailsById({ id: campaignId });
  return normalizeCampaignDetails(res);
}

export function fetchCampaignStatusData(campaignId, status, opts = {}) {
  const { page = 1, limit = 20, all = false } = opts;
  const query = all
    ? { all: "true" }
    : { page: String(page), limit: String(limit) };
  const qs = new URLSearchParams(query).toString();
  return apihubGet(
    `/getInteractedCustomerDetail/getcampaignstatusdata/${encodeURIComponent(campaignId)}/${encodeURIComponent(status)}?${qs}`,
  );
}

export async function loadCampaignDetailPage(campaignId, status = "failed", opts) {
  const [detailsRes, statusRes] = await Promise.all([
    fetchCampaignDetails(campaignId),
    fetchCampaignStatusData(campaignId, status, {
      all: status === "failed",
      ...opts,
    }).catch(() => null),
  ]);

  const statusPayload = unwrapCampaignStatusPayload(statusRes);
  return {
    campaign: normalizeCampaignDetails(detailsRes),
    statusList: statusPayload.data,
    statusTotal: statusPayload.total,
    statusPage: statusPayload.page ?? 1,
    statusLimit: statusPayload.limit ?? 20,
  };
}

export function fetchCampaignNames(phoneNumberId) {
  return postGetidandnameofcampaign({ phone_number_id: phoneNumberId });
}

export function fetchCampaignList(
  phoneNoId,
  { page = 1, limit = 10, search = "", tabFilter = "All" } = {},
) {
  return fetchAllcampaignByPhoneNoId(
    { phoneNoId },
    { page, limit, search, tabFilter },
  );
}
